"use client";
import { jsx } from "react/jsx-runtime";
import * as React from "react";
const localizationContext = React.createContext({
  language: "no"
});
const LocalizationProvider = ({ children, language }) => jsx(localizationContext.Provider, { value: { language }, children });
function useLocalization() {
  return React.useContext(localizationContext);
}
function useLanguage() {
  return useLocalization().language;
}
export {
  LocalizationProvider,
  useLanguage,
  useLocalization
};
